
import { Injectable } from '@angular/core';
import { OrdersService } from '@app/core/services';
import { ToastsService } from '@app/core/services/toasts.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import {
  deleteShippingSearchDownload,
  deleteShippingSearchDownloadSuccess,
  loadShippingSearchDownloads,
  loadShippingSearchDownloadsSuccess,
  saveShippingReport,
  saveShippingReportSuccess,
  saveShippingSearch,
  saveShippingSearchSuccess
} from '../actions/order.actions';
import { AppState } from '../reducers';

@Injectable()
export class OrderEffects {

  constructor(
    protected actions: Actions,
    private ordersService: OrdersService,
    private toastService: ToastsService,
    private store: Store<AppState>
  ) { }

  saveShippingSearch = createEffect(() => {
    return this.actions.pipe(
      ofType(saveShippingSearch),
      map((shippingSearch) => {
        return saveShippingSearchSuccess(shippingSearch);
      })
    )
  });

  saveShippingReport = createEffect(() => {
    return this.actions.pipe(
      ofType(saveShippingReport),
      map((shippingReport) => {
        return saveShippingReportSuccess(shippingReport);
      })
    )
  });

  loadShippingSearchDownloads = createEffect(() => {
    return this.actions.pipe(
      ofType(loadShippingSearchDownloads),
      distinctUntilChanged(),
      switchMap(() => this.ordersService.getShippingSearchDownloads()),
      map((shippingSearchDownload) => {
        return loadShippingSearchDownloadsSuccess({ payload: shippingSearchDownload });
      })
    )
  });

  deleteShippingSearchDownload = createEffect(() => {
    return this.actions.pipe(
      ofType(deleteShippingSearchDownload),
      switchMap(action => {
        return this.ordersService.deleteShippingSearchDownload(action.shippingSearchDownload.downloadId).pipe(
          map(() => {
            return deleteShippingSearchDownloadSuccess({ shippingSearchDownload: action.shippingSearchDownload });
          })
        )
      })
    )
  });

  deleteShippingSearchDownloadSuccess = createEffect(() => this.actions.pipe(
    ofType(deleteShippingSearchDownloadSuccess),
    map(action => {
      this.store.dispatch(loadShippingSearchDownloads());
      const toastMessage = ` <strong>${action.shippingSearchDownload.downloadName}</strong> was deleted.`
      this.toastService.success(toastMessage);
    })
  ), { dispatch: false });

}
